import React from 'react';
import { compose } from 'ramda';
import { RichText, Icon, Button } from '@synergycms_core/components/generic';
import PropertyManager from '@synergycms_core/components/HoC/propertyManager';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';
import { withContent } from '@synergycms_core/components/providers/translateProvider';
import styleFile from './engineBoxPromo.js';
import { CSSTransition } from 'react-transition-group';

import EnginePromotionalCode from './EnginePromotionalCode.jsx';

class EngineBoxPromo extends React.Component {
  static displayName = 'EngineBoxPromo';

  constructor(props) {
    super(props);

    const {
      promoVisible,
      promoCode
    } = this.props.config.promoManager;

    const codeApplied = !!promoCode;

    this.state = {
      promoVisible: promoVisible,
      promoCode: promoCode.toUpperCase(),
      codeApplied: codeApplied
    };
    this.cx = props.theme.bind();
  }


  isMobile = () => {
    return this.props.theme.deviceType !== 'DESK';
  };



  toggleBox = () => {
    const {
      toggleBox,
    } = this.props.config;

    
    let toggleBoxFn = toggleBox(null, 'promo')
    return toggleBoxFn
  }

  cleanPromo = e => {
    e.preventDefault();
    this.setState(state => {
      return {
        promoCode: '',
        codeApplied: false,
        promoVisible: false
      };
    }, () => {
      this.props.config.promoManager.updatePromoCode(this.state.promoCode);
    });
  }

  clearSearch = e => {
    e.preventDefault();
    this.setState({ promoCode: '', codeApplied: false })
  };

  onChange = event => {
    event.preventDefault();
    const value = event && event.target.value.toUpperCase();
    this.setState(state => {
      return { promoCode: value };
    });
  };

  applyCode = e => {
    e.preventDefault();
    this.setState(state => {
      return {
        codeApplied: true
      };
    }, () => {
      this.props.config.promoManager.updatePromoCode(this.state.promoCode);
    });
  };

  static getDerivedStateFromProps(props, state) {
    if (props.config.promoManager.promoVisible !== state.promoVisible) {
      return { promoVisible: props.config.promoManager.promoVisible };
    }
    return null;
  }

  showOnlyButton = (btnText) => {
    const { classes } = this.props.theme.styles;
    const { showModalView } = this.props.config;

    const btnClass = this.isMobile() && !showModalView ? classes.outsideButton : classes.insideButton

    return <Button
      innerStyle={btnClass}
      onClick={this.toggleBox()}
      
      richText={{
        text: btnText,
        translate: true,
        ucFirst: true,
        innerStyle: [classes.insideButtonSpan],
        icon: {
          unicodeContent: 'e06f',
          innerStyle: [classes.insertCodeIcon]
        }
      }}
    />
  }

  showElements = (btnText) => {
    const { classes } = this.props.theme.styles;
    const { codeApplied, promoCode } = this.state;
    const { modalBreak } = this.props.config;

    if(codeApplied){
      return <div className={classes.codeApliedContainer}>
        {modalBreak && <Icon unicodeContent={'e06f'} innerStyle={classes.iconsEngine} />}
        <RichText
          translate={true}
          text={'_%aplicado%_'}
          ucFirst={true}
          innerStyle={classes.insertCode}
        />
        <RichText
          translate={true}
          text={promoCode}
          ucFirst={true}
          innerStyle={classes.codeAppliedText}
        />
        <Button
          innerStyle={classes.removeCode}
          onClick={this.cleanPromo}
          icon={{
            unicodeContent: 'e001',
          }}
        />
      </div>
    }

    return this.showOnlyButton(btnText)
  }

  render() {
    const { config, theme } = this.props;
    const { classes } = theme.styles;
    const {
      showModalView,
      visibleType,
      dropDown,
      dropDownPosition,
      engineMerged,
      modalBreak
    } = config;

    const { promoCode, promoVisible } = this.state;
    const showBtnText = !engineMerged || engineMerged && theme.width > 1200;
    //Desktop version
    if(!modalBreak){
      return <div className={[theme.computedInnerStyle, this.cx({ engineMerged: engineMerged })].join(' ')}>
        <div className={classes.promoContainer} id={'promoBox'}>

          {this.showElements(showBtnText && '_%código promocional%_')}

          <EnginePromotionalCode
              showModalView={showModalView}
              promoVisible={promoVisible}
              promoCode={promoCode}
              clearSearch={this.clearSearch}
              onChange={this.onChange}
              applyCode={this.applyCode}
              dropDownPosition={dropDownPosition}
              modalBreak={modalBreak}
              engineMerged={engineMerged}
            />
        </div>
      </div>
    }

    //Mobile version
    if(modalBreak && !showModalView){
      return (<div className={[theme.computedInnerStyle].join(' ')}>
        <div className={classes.promoContainer}>

          {this.showOnlyButton('_%código promocional%_')}

        </div>
      </div>)
    }

    
    return (<CSSTransition
      in={visibleType === 'promo' || !dropDown}
      timeout={700}
      mountOnEnter
      unmountOnExit
      classNames={{
        enter: classes.inputEnter,
        enterActive: classes.inputEnterActive,
        exit: classes.inputLeave,
        exitActive: classes.inputLeaveActive
      }}>
      <div className={[theme.computedInnerStyle].join(' ')}>
        <div className={classes.promoContainer}>
          
          {!promoVisible && this.showElements('_%tengo un código promocional%_')}

          <EnginePromotionalCode
            showModalView={showModalView}
            promoVisible={promoVisible}
            promoCode={promoCode}
            clearSearch={this.clearSearch}
            onChange={this.onChange}
            applyCode={this.applyCode}
            dropDownPosition={dropDownPosition}
            modalBreak={modalBreak}
            engineMerged={engineMerged}
          />
        </div>
      </div>
    </CSSTransition>)

  }
  
}

export default compose(
  PropertyManager([
    'classes',
    'promoManager',
    'showModalView',
    'toggleBox',
    'visibleType',
    'dropDown',,
    'engineMerged',
    'dropDownPosition',
    'modalBreak'
  ]),
  withThemeJSS({ styleFile, link: true, index: 100 }),
  withContent('i18n')
)(EngineBoxPromo);
